import { motion } from "framer-motion";

const socialLinks = [
  { label: "X / Twitter", href: "https://x.com/ZiraMinds_AI" },
  { label: "Instagram", href: "https://www.instagram.com/ziraminds.ai/" },
  { label: "LinkedIn", href: "https://www.linkedin.com/company/ziraminds-ai/" },
];

const buildReadLinks = [
  { label: "GitHub", href: "https://github.com/ZiraMinds-AI" },
  { label: "Medium", href: "https://medium.com/@social.ziraminds" },
];

const MAILTO =
  "mailto:hello.ziraminds@gmail.com?subject=Hello%20ZiraMinds%20AI";

export default function ContactSection() {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative w-full py-32 md:py-48"
    >
      <div className="w-full max-w-screen-2xl mx-auto px-6 md:px-12 xl:px-24">
        <div className="flex items-center gap-3 mb-16 md:mb-24">
          <span className="font-mono text-xs uppercase tracking-[0.3em] text-[#d4ff00]">
            /04
          </span>
          <span className="font-mono text-xs uppercase tracking-[0.3em] text-[#8a8a8a]">
            Connect
          </span>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
        >
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#8a8a8a] mb-6">
            Build with us / partner / hire / collaborate
          </p>

          <a
            href={MAILTO}
            data-testid="contact-email-link"
            data-cursor="hover"
            className="group block"
            aria-label="Email ZiraMinds AI"
          >
            <span
              className="font-display uppercase tracking-tightest text-white group-hover:text-[#d4ff00] transition-colors duration-500"
              style={{ fontSize: "clamp(2.2rem, 9vw, 10rem)", lineHeight: 0.9 }}
            >
              connect@
            </span>
            <span
              className="font-display uppercase tracking-tightest text-white group-hover:text-[#d4ff00] transition-colors duration-500 block"
              style={{ fontSize: "clamp(2.2rem, 9vw, 10rem)", lineHeight: 0.9 }}
            >
              ziraminds.ai
              <span className="inline-block ml-4 transition-transform duration-500 group-hover:translate-x-4">
                →
              </span>
            </span>
          </a>
        </motion.div>

        <div className="mt-24 md:mt-32 grid grid-cols-12 gap-x-6 gap-y-12 border-t border-white/10 pt-10">
          <div className="col-span-12 md:col-span-3">
            <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#4a4a4a]">
              Studio
            </span>
            <p className="mt-2 font-body text-sm text-white">
              Chennai, IN — Remote / Distributed
            </p>
          </div>

          <div className="col-span-6 md:col-span-3">
            <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#4a4a4a]">
              Social
            </span>
            <ul className="mt-2 space-y-2">
              {socialLinks.map((s) => (
                <li key={s.label}>
                  <a
                    href={s.href}
                    target="_blank"
                    rel="noreferrer"
                    data-testid={`social-${s.label.toLowerCase().replace(/[^a-z]/g, "")}`}
                    className="font-mono text-xs uppercase tracking-[0.25em] text-white link-underline"
                  >
                    {s.label} ↗
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="col-span-6 md:col-span-3">
            <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#4a4a4a]">
              Build / Read
            </span>
            <ul className="mt-2 space-y-2">
              {buildReadLinks.map((s) => (
                <li key={s.label}>
                  <a
                    href={s.href}
                    target="_blank"
                    rel="noreferrer"
                    data-testid={`social-${s.label.toLowerCase().replace(/[^a-z]/g, "")}`}
                    className="font-mono text-xs uppercase tracking-[0.25em] text-white link-underline"
                  >
                    {s.label} ↗
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="col-span-12 md:col-span-3">
            <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#4a4a4a]">
              Posture
            </span>
            <p className="mt-2 font-body text-sm text-[#8a8a8a] leading-relaxed">
              We respond to thoughtful inquiries — research, deployments,
              partnerships &amp; rare hires.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
